export default "__VITE_ASSET__CZ1hgCD2__"